import { render, staticRenderFns } from "./site-facing-read-only-wrapper.vue?vue&type=template&id=683914c8&scoped=true&"
import script from "./site-facing-read-only-wrapper.vue?vue&type=script&lang=js&"
export * from "./site-facing-read-only-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./site-facing-read-only-wrapper.vue?vue&type=style&index=0&id=683914c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683914c8",
  null
  
)

component.options.__file = "site-facing-read-only-wrapper.vue"
export default component.exports